// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"516":"635f6265","538":"8d39612c","971":"73ebb03c"}[chunkId] + ".chunk.css";
};